import service from './service';
import serviceTwo from './serviceTwo';
import DateUtils from '../../utils/date-utils';
import { UrlBuilder } from './url-builder';

export const list = async (filter, page, pageSize) => {
  const { reportDate } = filter;

  const response = await service.get(
    `/geofences?page=${page}&pageSize=${pageSize}&occupants=true&reportDate=${
      reportDate ?? DateUtils.today()
    }`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByAllCompany = async ({ companyId, occupants, reportDate }, page, pageSize) => {
  if (!companyId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const response = await service.get(
    `/companies/${companyId}/geofences?occupants=${occupants ?? false}&reportDate=${
      reportDate ?? DateUtils.today()
    }&page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByCompanyManager = async (
  { companyId, occupants, reportDate },
  page,
  pageSize
) => {
  if (!companyId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const response = await service.get(
    `/users/self/geofences?occupants=${occupants ?? false}&reportDate=${
      reportDate ?? DateUtils.today()
    }&page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByCompany = async ({ companyId, occupants, reportDate }, page, pageSize) => {
  if (!companyId) return { items: [], length: 0, page: 0, pageSize: 10 };

  // const response = await service.get(
  //   `/companies/${companyId}/geofences?occupants=${occupants ?? false}&reportDate=${
  //     reportDate ?? DateUtils.today()
  //   }&page=${page}&pageSize=${pageSize}`
  // );

  const response = await service.get(
    `/companies/${companyId}/geofences?page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllGeofencesByCompany = async (companyId) => {
  if (!companyId) return { items: [] };

  const response = await service.get(`/companies/${companyId}/geofences?mode=ALL`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllByCompany = async (companyId, { occupants, reportDate }) => {
  if (!companyId) return [];

  const builder = new UrlBuilder(`/companies/${companyId}/geofences`);
  builder.add('occupants', occupants);
  builder.add('reportDate', reportDate);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByPartner = async (
  partnerId,
  { companyId, name, occupants, reportDate },
  page,
  pageSize
) => {
  if (!partnerId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/partners/${partnerId}/geofences`);
  builder.add('companyId', companyId);
  builder.add('reportDate', reportDate);
  builder.add('occupants', occupants);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const geofencesListByAdmin = async (
  { companyId, name, occupants, reportDate },
  page,
  pageSize
) => {
  const builder = new UrlBuilder(`/admin/geofences`);
  builder.add('companyId', companyId);
  builder.add('reportDate', reportDate);
  builder.add('occupants', occupants);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const geofencesListForAdminReport = async (companyFilter) => {
  const builder = new UrlBuilder(`/admin/geofences`);

  builder.add('mode', 'ALL');
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllGeofencesByCompanyAsDistributor = async (partnerId, companyFilter) => {
  if (!partnerId) return { items: [] };

  const builder = new UrlBuilder(`/partners/${partnerId}/geofences`);
  builder.add('mode', 'ALL');
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllByPartner = async (
  partnerId,
  companyId
  // { companyId, name, occupants, reportDate }
) => {
  if (!partnerId) return [];

  const builder = new UrlBuilder(`/partners/${partnerId}/geofences`);
  builder.add('companyId', companyId);
  // builder.add('reportDate', reportDate);
  // builder.add('occupants', occupants);
  // builder.add('name', name);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllByAdmin = async (companyFilter) => {
  const builder = new UrlBuilder(`/admin/geofences`);

  builder.add('mode', 'ALL');
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByPartner = async (partnerId, { companyId }, page, pageSize) => {
  if (!partnerId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/partners/${partnerId}/geofences/count`);
  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByAdmin = async ({ companyId }) => {
  const builder = new UrlBuilder(`/admin/geofences/count`);
  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listByParent = async (
  parentId,
  { companyId, name, occupants, reportDate },
  page,
  pageSize
) => {
  if (!parentId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/parents/${parentId}/geofences`);
  builder.add('companyId', companyId);
  builder.add('reportDate', reportDate);
  builder.add('occupants', occupants);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllByParent = async (parentId, { companyId, name, occupants, reportDate }) => {
  if (!parentId) return [];

  const builder = new UrlBuilder(`/parents/${parentId}/geofences`);
  builder.add('companyId', companyId);
  builder.add('reportDate', reportDate);
  builder.add('occupants', occupants);
  builder.add('name', name);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByParent = async (
  parentId,
  { companyId, name, occupants, reportDate },
  page,
  pageSize
) => {
  if (!parentId) return { items: [], length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/parents/${parentId}/geofences/count`);
  builder.add('companyId', companyId);
  builder.add('reportDate', reportDate);
  builder.add('occupants', occupants);
  builder.add('name', name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const countByCompany = async (companyId) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/companies/${companyId}/geofences/count`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const createGeofence = async (geofence) => {
  const builder = new UrlBuilder(`/geofences`);

  const response = await service.post(builder.toString(), geofence);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateGeofence = async (geofence) => {
  const builder = new UrlBuilder(`/geofences/${geofence._id}`);

  const response = await service.put(builder.toString(), geofence);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const partnerCreateGeofence = async (partnerId, geofence) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/geofences`);

  const response = await service.post(builder.toString(), geofence);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const remove = async (geofence) => {
  const builder = new UrlBuilder(`/geofences/${geofence._id}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return true;
  }

  return false;
};

export const partnerGeofenceRemove = async (geofence) => {
  const builder = new UrlBuilder(`/geofences/${geofence}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return true;
  }

  return false;
};

export const getGeofencesByPremiseId = async (premisesId) => {
  const builder = new UrlBuilder(`/premises/${premisesId}/geofence`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listAllGeofencesByManager = async (companyId, premiseID, page, pageSize) => {
  if (!companyId) return [];
  const builder = new UrlBuilder(`/company/${companyId}/premise/${premiseID}/geofence`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());
  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listAllGeofencesByManagerForReport = async (companyId, premiseID) => {
  if (!companyId) return [];
  const builder = new UrlBuilder(`/company/${companyId}/premise/${premiseID}/geofence`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());
  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const getListOfAlertReceivers = async (payload) => {
  const builder = new UrlBuilder(`/geofence/list-applicable-alert-receivers`);

  const response = await serviceTwo.postTwo(builder.toString(), payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

// export const updateGeofence = async (geofence) => {
//   if (!geofence.id) return undefined;

//   const response = await service.put(`/geofences/${geofence.id}`, geofence);

//   if (response.status === 200) {
//     const data = response.data;

//     return data;
//   }

//   return undefined;
// };

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  list,
  listByCompany,
  listAllByCompany,
  listByCompanyManager,
  listByPartner,
  listAllByPartner,
  listByParent,
  listAllByParent,
  countByPartner,
  countByParent,
  countByCompany,
  createGeofence,
  partnerCreateGeofence,
  remove,
  getGeofencesByPremiseId,
  updateGeofence,
  partnerGeofenceRemove,
  listAllGeofencesByManager,
  listAllGeofencesByCompanyAsDistributor,
  countByAdmin,
  listAllByAdmin,
};
